<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.BILL_CHARGE' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.BILL_CHARGE' | translate }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="billChargeForm">
        <div class="row m-t-30">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.BILL_CHARGE' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.BILL_CHARGE' | translate }}" formControlName="name">
                    <mat-error *ngIf="billChargeForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="billChargeForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="insuranceChargeCategoryId" placeholder="{{ 'LABEL.INSURANCE_CHARGE_CATEGORY' | translate }}">
                        <mat-option *ngFor="let category of InsuranceChargeCategoryList" [value]="category">
                                {{ InsuranceChargeCategoryData[category] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.BILL_CHARGE_VALUE' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.BILL_CHARGE_VALUE' | translate }}" formControlName="charge" type="number">
                    <mat-error
                        *ngIf="billChargeForm.get('charge')?.hasError('required') && billChargeForm.get('charge')?.touched">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error
                        *ngIf="billChargeForm.get('charge')?.hasError('pattern') && billChargeForm.get('charge')?.touched && !billChargeForm.get('charge')?.hasError('required')">
                        {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                    </mat-error>
                    <mat-error
                        *ngIf="billChargeForm.get('charge')?.hasError('maxlength') && billChargeForm.get('charge')?.touched && !billChargeForm.get('charge')?.hasError('required') && !billChargeForm.get('charge')?.hasError('pattern')">
                        {{ 'REQUIRED.MAXIMUM10' | translate }}
                    </mat-error>

                </mat-form-field>

            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{ 'LABEL.DEFAULT_LABEL' | translate }}:</strong></mat-label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox class="example-margin" color="warn" formControlName="isDefault"></mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-9"></div>
            <div class="col-lg-3" style="display: flex; justify-content: flex-end;">
                <button mat-stroked-button (click)="OnCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate }}</button>
                <button mat-flat-button color="warn" class="m-l-4" (click)="onUpdateBillCharge()" *ngIf="isEdit"
                    [disabled]="billChargeForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

                <button mat-flat-button color="warn" class="m-l-4" (click)="onSaveBillCharge()" *ngIf="!isEdit"
                    [disabled]="billChargeForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            </div>
        </div>
    </form>
</div>